<template>
  <kst-page-edit
    @init="handleInit"
    @submit="handleSubmit"
  >
    <Details :userData="userData"/>
  </kst-page-edit>
</template>

<script>
import InputPageMixin from "../../../mixins/InputPageMixin.js";
import Model from "../SpModel.js";
import Services from "../../../services/Api/SpecialPriceServices.js";

import Details from "./SpE_Details.vue";

export default {
  components: {
    Details,
  },
  mixins: [InputPageMixin],
  data: () => ({
    userData: {},
  }),
  methods: {
    /*** by page ***/

    handleInit(id, loadEdit) {
      this.resetData();

      const config = Services.getEditData(id);
      loadEdit(config, this.handleInit_Success);
    },
    handleInit_Success(data) {
      Model.Edit.setDetailsByData(this.userData, data.Details);
    },

    handleSubmit(saveData) {
      let data = Model.populateData(this.userData);
      const config = Services.putData(data);
      saveData(config, this.handleSubmit_Success);
    },
    handleSubmit_Success() {
      this.disableRouteLeave();
    },

    /*** custom ***/

    resetData() {
      this.userData = Model.createDetails();
    }
  }
}
</script>